import { useMemo } from 'react'

const mobileIOSDeviceRegexp = /\b(iPad|iPhone)\b/

export function useDetectIPhone() {
  return useMemo(() => mobileIOSDeviceRegexp.test(navigator.userAgent), [])
}
